const zh = {
    title: '钱包指引',

    baseTitle: '基础知识',
    baseContent1: '什么是区块链？',
    baseUrl1: 'https://tphelp.gitbook.io/cn/the-basics/what-is-blockchain',
    baseContent2: '什么是去中心化钱包？',
    baseUrl2: 'https://tphelp.gitbook.io/cn/the-basics/what-is-a-decentralized-wallet',
    baseContent3: '什么是私钥、助记词、密码？',
    baseUrl3: 'https://tphelp.gitbook.io/cn/the-basics/what-is-a-private-key-mnemonic-and-password',
    baseContent4: '什么是矿工费？',
    baseUrl4: 'https://tphelp.gitbook.io/cn/the-basics/what-is-the-miner-fee',
    baseContent5: '什么是硬件钱包？',
    baseUrl5: 'https://help.tokenpocket.pro/cn/the-basics/Hardware-Wallet',
    baseContent6: '什么是冷钱包？',
    baseUrl6: 'https://help.tokenpocket.pro/cn/the-basics/Cold-Wallet',
    baseContent7: '什么是热钱包？',
    baseUrl7: 'https://help.tokenpocket.pro/cn/the-basics/Hot-Wallet',
    baseContent8: '什么是观察钱包？',
    baseUrl8: 'https://help.tokenpocket.pro/cn/the-basics/Watch-the-wallet',
    baseContent9: '什么是多签钱包？',
    baseUrl9: 'https://help.tokenpocket.pro/cn/the-basics/Multisig',
    baseContent10: '什么是插件钱包？',
    baseUrl10: 'https://help.tokenpocket.pro/cn/the-basics/Plug-in',
    safeTitle: '安全知识',
    safeTitle1: '常见诈骗案例',
    safeTitle2: '安全措施',
    safeContent1: '假空投诈骗',
    safeUrl1: 'https://tphelp.gitbook.io/cn/secirity-knowledge/fraud-cases/airdrop-fraud',
    safeContent2: '假App诈骗',
    safeUrl2: 'https://tphelp.gitbook.io/cn/secirity-knowledge/fraud-cases/fake-app-fraud',
    safeContent3: '钓鱼网站诈骗',
    safeUrl3: 'https://tphelp.gitbook.io/cn/secirity-knowledge/fraud-cases/phishing-website-fraud',
    safeContent4: '假代币诈骗',
    safeUrl4: 'https://tphelp.gitbook.io/cn/secirity-knowledge/fraud-cases/fake-tokens-fraud',
    safeContent5: '假客服诈骗',
    safeUrl5: 'https://tphelp.gitbook.io/cn/secirity-knowledge/fraud-cases/fake-customer-service-fraud',
    safeContent6: '假二维码诈骗',
    safeUrl6: 'https://tphelp.gitbook.io/cn/secirity-knowledge/fraud-cases/fake-code-scam',
    safeContent7: '应用授权诈骗',
    safeUrl7: 'https://tphelp.gitbook.io/cn/secirity-knowledge/fraud-cases/dapp-approve-fraud',
    safeContent8: '助记词诈骗',
    safeUrl8: 'https://help.tokenpocket.pro/cn/secirity-knowledge/fraud-cases/tron-phishing-wallet',
    safeContent9: '"零金额"转账骗局',
    safeUrl9: 'https://help.tokenpocket.pro/cn/secirity-knowledge/fraud-cases/zero-tansfer',
    safeContent10: '精准伪装地址骗局',
    safeUrl10: 'https://help.tokenpocket.pro/cn/secirity-knowledge/fraud-cases/pretender',
    safeContent11: '资产防盗措施',
    safeUrl11: 'https://tphelp.gitbook.io/cn/secirity-knowledge/protective-measures/assets-theft-prevention',
    safeContent12: '资产防丢措施',
    safeUrl12: 'https://tphelp.gitbook.io/cn/secirity-knowledge/protective-measures/assests-loss-prevention',
    safeContent13: '取消恶意授权指引',
    safeUrl13: 'https://help.tokenpocket.pro/cn/secirity-knowledge/protective-measures/TP-Approve',
    safeContent14: '代币合约检测工具使用指引',
    safeUrl14: 'https://help.tokenpocket.pro/cn/secirity-knowledge/protective-measures/Token-Detection',
    safeContent15: '官网正版钱包验证方法',
    safeUrl15: 'https://help.tokenpocket.pro/cn/secirity-knowledge/protective-measures/verification',
    safeContent16: 'GooglePlay正版钱包验证方法',
    safeUrl16: 'https://help.tokenpocket.pro/cn/secirity-knowledge/protective-measures/google',
    safeContent17: '隐藏小额交易记录',
    safeUrl17: 'https://help.tokenpocket.pro/cn/secirity-knowledge/protective-measures/hide',
    DeFiTitle: 'DEX教程',
    DeFiTitle1: '怎么在DEX交易',
    DeFiTitle2: '其他',
    DeFiContent1: '什么是DeFi？',
    DeFiUrl1: 'https://tphelp.gitbook.io/cn/what-is-defi',
    DeFiContent2: '什么是去中心化交易所（DEX）',
    DeFiUrl2: 'https://tphelp.gitbook.io/cn/about-dex',
    DeFiContent3: 'Transit使用教程',
    DeFiUrl3: 'https://tphelp.gitbook.io/cn/how-to-trade-on-dex/xswap2.0-guide',
    DeFiContent4: 'Polygon (Matic) 使用教程',
    DeFiUrl4: 'https://tphelp.gitbook.io/cn/how-to-trade-on-dex/transfer-assets-from-ethereum-and-bsc-to-polygon',
    DeFiContent5: 'Uniswap使用教程',
    DeFiUrl5: 'https://tphelp.gitbook.io/cn/how-to-trade-on-dex/dex-uniswap',
    DeFiContent6: 'PancakeSwap使用教程',
    DeFiUrl6: 'https://tphelp.gitbook.io/cn/how-to-trade-on-dex/dex-pancakeswap',
    DeFiContent7: 'MDEX使用教程',
    DeFiUrl7: 'https://tphelp.gitbook.io/cn/how-to-trade-on-dex/dex-mdex',
    DeFiContent8: 'JustSwap使用教程',
    DeFiUrl8: 'https://tphelp.gitbook.io/cn/how-to-trade-on-dex/dex-justswap',
    DeFiContent9: 'Pudding使用教程',
    DeFiUrl9: 'https://tphelp.gitbook.io/cn/how-to-trade-on-dex/dex-puddingswap',
    DeFiContent10: 'SushiSwap使用教程',
    DeFiUrl10: 'https://tphelp.gitbook.io/cn/how-to-trade-on-dex/dex-sushi',
    DeFiContent11: '向我们提交DApp',
    DeFiUrl11: 'https://tphelp.gitbook.io/cn/how-to-submit-dapp',
    normalTitle: '常见问题',
    normalContent1: '不同公链间不能直接转账',
    normalUrl1: 'https://tphelp.gitbook.io/cn/fqa/transfer-from-different-chains',
    normalContent2: '交易所【提现资产】到钱包未到账',
    normalUrl2: 'https://tphelp.gitbook.io/cn/fqa/fail-to-receive-assets-from-exchanges',
    normalContent3: '钱包【充值资产】到交易所未到账',
    normalUrl3: 'https://tphelp.gitbook.io/cn/fqa/fail-to-receive-assets-from-wallet',
    normalContent4: '我往合约转账了，怎么办？',
    normalUrl4: 'https://tphelp.gitbook.io/cn/fqa/do-not-transfer-to-contract-address',
    normalContent5: '为什么转账一直在打包，怎么办？',
    normalUrl5: 'https://tphelp.gitbook.io/cn/fqa/pending-status-transfer',
    normalContent6: '我转账记录失败了，为什么不给我退币？',
    normalUrl6: 'https://tphelp.gitbook.io/cn/fqa/why-do-not-return-my-coins',
    tokenTitle: '代币管理',
    tokenTitle1: '其他',
    tokenContent1: '搜索代币',
    tokenUrl1: 'https://tphelp.gitbook.io/cn/token-management/add-token',
    tokenContent2: '添加代币',
    tokenUrl2: 'https://tphelp.gitbook.io/cn/token-management/add-token',
    tokenContent3: '删除代币',
    tokenUrl3: 'https://tphelp.gitbook.io/cn/token-management/delete-token',
    tokenContent4: '接收代币',
    tokenUrl4: 'https://tphelp.gitbook.io/cn/transfer-tutorial/receive-token',
    tokenContent5: '向我们提交代币',
    tokenUrl5: 'https://tphelp.gitbook.io/cn/token-management/submit-token',
    walletTitle: '钱包管理',
    walletContent1: '创建钱包',
    walletUrl1: 'https://tphelp.gitbook.io/cn/wallet-management/create-wallet',
    walletContent2: '导入钱包',
    walletUrl2: 'https://tphelp.gitbook.io/cn/wallet-management/import-wallet',
    walletContent3: '管理钱包',
    walletUrl3: 'https://tphelp.gitbook.io/cn/wallet-management/manage-wallet',
    walletContent4: '切换钱包',
    walletUrl4: 'https://tphelp.gitbook.io/cn/wallet-management/switch-wallet',
    walletContent5: '同步钱包',
    walletUrl5: 'https://tphelp.gitbook.io/cn/wallet-management/wallet-data-migration',
    transferTitle: '转账教程',
    transferTitle1: '转账高级功能',
    transferContent1: '怎么转账',
    transferUrl1: 'https://tphelp.gitbook.io/cn/transfer-tutorial/receive-token',
    transferContent2: '转账到钱包',
    transferUrl2: 'https://theodore-ratliff.gitbook.io/fen-xiang/CN/withdraw-from-exchange',
    transferContent3: '转账到交易所',
    transferUrl3: 'https://tphelp.gitbook.io/cn/transfer-tutorial/transfer-to-the-wallet-or-exchange',
    transferContent4: '加速交易',
    transferUrl4: 'https://tphelp.gitbook.io/cn/transfer-tutorial/ru-he-jia-su-zhuan-zhang-jiao-yi',
    transferContent5: '取消交易',
    transferUrl5: 'https://tphelp.gitbook.io/cn/transfer-tutorial/cancel-and-accelerate-transfer',
    transferContent6: '发送链上备注',
    transferUrl6: 'https://tphelp.gitbook.io/cn/transfer-tutorial/add-memo',

    headerUrl: require('../../assets/header_zh.png'),
    more: '更多教程',
    moreUrl: 'https://www.yuque.com/tokenpocket/',
    basicTitle: '基础知识',
    basicSubtitle: '区块链术语的入门知识',
    securityTitle: '安全知识',
    securitySubtitle: '钱包安全，从防骗开始',
    testAndAward: '开始答题，<span class="earn">赢取奖励</span>',
    testAndAwardDesc: '掌握钱包基础知识，教你避开「诈骗陷阱」',
    testAndAwardUrl: 'https://www.wenjuan.ltd/s/RzeAz2W/#'
};

export default zh;
